import { AxiosResponse } from "axios";
import { put } from "redux-saga/effects";
import { confirmPaymentActionSuccess, createPaymentActionFail, createPaymentActionSuccess } from "../actions/actions";
import { paymentApi } from "../../services/apiGate";

//* get all categories  

export function* createPaymentSaga(action: any) {
    try {
        console.log("Saga started with action:", action);

        let response: AxiosResponse = yield paymentApi.createPayment(action.order);

        console.log("Payment API Response:", response);

        if (response.status == 204) {
            console.log("Payment returned 204 (No Content).");
        }

        if (response.status == 200) {
            let data = response.data;
            console.log('PAYMENT MESSAGE =>>>>>', data);

            if (data.error) {
                yield put(createPaymentActionFail(data.error));
            } else {
                yield put(createPaymentActionSuccess(data.data));
            }
        } else {
            console.log(`Unexpected status: ${response.status}`);
        }
    } catch (error: any) {
        console.error("🚀 ~ function*createPaymentSaga ~ error:", error);
        yield put(createPaymentActionFail(error));
    }
}


export function* confirmPaymentSaga(action: any) {
    try {
        let response: AxiosResponse = yield paymentApi.confirmPayment(action.order)

        if (response.data) {

            let data = response.data

            yield put(confirmPaymentActionSuccess(data))
        }
    } catch (error: any) {



    }
}
